/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import MessageModal from '../../components/Modals/MessageModal';
import paths from '../../paths';

const parseResponse = (response) => {
  if (response.status === 200) {
    return response.data;
  }

  throw { status: response.status, data: response.data };
};

const handleError = (response, showDefaultError) => {
  if (response.status === 401 && response.data && response.data.code == 1) {
    window.location.href = `/signout`;
    return;
  }

  if (response.status === 403) {
    if (response.data) {
      response.data.msg = 'Недостаточно прав для выполнения данной операции.';
    }
    throw { status: response.status, data: response.data };
  }

  if (response.status === 404) {
    window.location.replace(paths.advocates.notFound);
    return;
  }

  if (response.status === 503) {
    const modalRoot = document.getElementById('modal-root');
    ReactDOM.render(
      <MessageModal
        visible
        message={`Сервер не может обработать данный запрос, попробуйте позже.`}
        hide={() => {
          ReactDOM.unmountComponentAtNode(modalRoot);
        }}
      />,
      modalRoot
    );
  }

  if (showDefaultError && response.data.message) {
    const modalRoot = document.getElementById('modal-root');
    ReactDOM.render(
      <MessageModal
        modificator="error"
        visible
        message={response.data.message}
        hide={() => {
          ReactDOM.unmountComponentAtNode(modalRoot);
        }}
      />,
      modalRoot,
    );
    return;
  }
};

export function apiRequest(
  url,
  options = { method: 'GET', credentials: 'same-origin' },
  showDefaultError = true,
) {
  options.url = url.toString();
  if (options.body) {
    options.data = options.body;
  }
  return axios(options)
    .then(res => parseResponse(res, showDefaultError))
    .catch((error) => {
      if (error.response) {
        handleError(error.response, showDefaultError);
      }
      throw error;
    });
}
